import { Component, OnInit, SimpleChanges, Input } from '@angular/core';

@Component({
  selector: 'app-master-rails-two',
  templateUrl: './master-rails-two.component.html',
  styleUrls: ['./master-rails-two.component.scss']
})
export class MasterRailsTwoComponent implements OnInit {


  @Input('learner') learner;
  @Input('job') job;
  @Input('assessment') assessmentPlanEdit;
  learnerId
  jobId
  jobData:any;
  layout = true
  assessmentEdit
  singleLearner
  constructor() { }

  ngOnInit() {
  }




  ngOnChanges(changes: SimpleChanges) {
    console.log("changes in master rail main", changes);
    if (changes.learner && changes.learner.currentValue) {
      this.singleLearner = changes.learner.currentValue
      this.learnerId = changes.learner.currentValue._id
    }

    if (changes.job && changes.job.currentValue) {
      this.jobId = changes.job.currentValue[0]._id
      this.jobData = changes.job.currentValue
    }

    // if (changes.summarySheetEdit && changes.summarySheetEdit.currentValue) {
    //     this.summarySheetEdit = changes.summarySheetEdit.currentValue
    // }

    if (changes.assessmentPlanEdit && changes.assessmentPlanEdit.currentValue) {
      console.log("changes.assessmentPlanEdit.currentValue in master", changes.assessmentPlanEdit.currentValue)
      this.assessmentEdit = changes.assessmentPlanEdit.currentValue
      console.log("assement plan edit data", this.assessmentEdit);

    }
  }

}
